module.exports = __webpack_public_path__ + "static/media/DescargarDoc.26e5f3fc.svg";